import React from "react";
import Form from "react-bootstrap/Form";
import "./Switch.css";

export const Switch = ({
  checked = false,
  onChange,
  label,
  title,
  id,
  className = "",
  disabled = false,
}) => {
  const switchId =
    id ||
    `switch-${String(label || "default")
      .toLowerCase()
      .replace(/\s+/g, "-")}`;

  return (
    <div
      className={`app-switch ${checked ? "app-switch--on" : "app-switch--off"} ${className}`.trim()}
      title={title}
    >
      <Form.Check
        type="switch"
        id={switchId}
        label={label}
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange?.(event.target.checked)}
      />
    </div>
  );
};
